import { useRef, useState } from "react";

export default function BeforeAfter({ before, after, alt = "before after" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const move = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  return (
    <div
      ref={ref}
      className="ba-wrap aspect-[4/3] w-full cursor-ew-resize"
      data-testid="before-after-slider"
      onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
      onTouchMove={(e) => move(e.touches[0].clientX)}
      onClick={(e) => move(e.clientX)}
    >
      <img src={before} alt={`${alt} before`} className="ba-before" draggable={false} />
      <img
        src={after}
        alt={`${alt} after`}
        className="ba-after"
        draggable={false}
        style={{ clipPath: `inset(0 0 0 ${pos}%)` }}
      />
      <div className="ba-handle" style={{ left: `${pos}%` }} />
      <div className="absolute top-3 left-3 label-pill bg-white/85 text-foreground">Before</div>
      <div className="absolute top-3 right-3 label-pill bg-primary text-primary-foreground">After</div>
    </div>
  );
}
